// extracted by mini-css-extract-plugin
export default {"root":"StartPage_root__2o91u","navigationBlock":"StartPage_navigationBlock__ys9+4","sectionTitle":"StartPage_sectionTitle__FdUQs"};